module.exports = __webpack_public_path__ + "7db9239a9afb61b62bca91cafdc8eaa4.png";